import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import { KopkarTable, SelectColumnFilter } from '../../components/KopkarTable';
import Icon from '../../components/Icon';
import Card from '../../components/SimpleCard';
import { baseAPI } from '../../services/baseAPI';
import { Users } from 'react-feather';

function ListAnggota() {

  //Roles
  const ADMIN = 1;
  const ANGGOTA = 2;
  const token = useUserStore((state) => state.token);
  const users = useUserStore((state) => state.user);

  const [modalAction, setModalAction] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [dataAnggota, setDataAnggota] = useState([]);

  // CONTROLLER & LOAD DATA
  const fetchDataAnggota = async () => {

    await baseAPI
      .get(`/v1/user`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const data = res.data.data.userData
        setDataAnggota(data)
        setIsLoading(false)
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(`error ${error}`);
      })
  };

  // not need delete anggota, just change the state from "Active" become "Non-Active"
  // const deleteAnggota = async (id) => {
  //   Swal.fire({
  //     title: 'Are you sure?',
  //     text: "All your recorded data (Tabungan, Mutasi, etc) also will be deleted, and you won't be able to revert this!",
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     cancelButtonColor: '#d33',
  //     confirmButtonText: 'Yes, delete it!'
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       setIsLoading(true);
  //       await baseAPI
  //         .delete(`/v1/user/${id}`, {
  //           headers: { Authorization: `Bearer ${token}` },
  //         })
  //         .then((res) => {
  //           Swal.fire({
  //             icon: 'success',
  //             title: 'User data has been deleted',
  //             showConfirmButton: false,
  //             timer: 1500
  //           })
  //         })
  //         .catch((error) => {
  //           setIsLoading(false);
  //           Swal.fire({
  //             icon: 'error',
  //             title: 'Delete data is failed',
  //             showConfirmButton: false,
  //             timer: 1500
  //           })
  //           console.log(`error ${error}`)
  //         })
  //         .finally(() => {
  //           fetchDataAnggota();
  //           setIsLoading(false);
  //         });
  //     }
  //   });
  // }

  useEffect(() => {
    setIsLoading(true);
    if (users.role === ADMIN) {
      fetchDataAnggota();
    }
  }, [token]);


  const contentTableAction = (id, username) => {
    if (id && username !== null) {
      return (
        <div className='text-center'>
          <Link 
            to={`/anggota/listanggota/editanggota/${id}/${username}`} 
            className="btn btn-primary"
            style={{ backgroundColor: "#CD5C08", marginRight: 10 }}
          >
            <Icon name="Edit" size={16} />
          </Link>
          {/* <button 
            className="btn btn-danger"
            onClick={() => deleteAnggota(id)}
          >
            <Icon name="Trash" size={16} />
          </button> */}
        </div>
      )
    }
  };

  const userListView = () => {
    const columns = [
      {
        Header: 'No',
        id: 'row',
        width: '2%',
        accessor: 'no',
        sortType: 'basic',
        disableFilters: true,
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.index + 1}</div>,
      },
      {
        Header: 'NPP',
        id: 'npp',
        width: '5%',
        accessor: 'npp',
        sortType: 'basic',
        disableFilters: true,
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.npp_anggota}</div>
      },
      {
        Header: 'Nama',
        id: 'nama',
        width: '12%',
        accessor: 'nama',
        sortType: 'basic',
        disableFilters: true,
        Cell: (cellInfo) => <div className='text-left'>{cellInfo.row.original.name_anggota}</div>
      },
      {
        Header: 'Email',
        id: 'email',
        width: '12%',
        accessor: 'email',
        sortType: 'basic',
        disableFilters: true,
        // filter: 'includes',
        // Filter: SelectColumnFilter,
        Cell: (cellInfo) => <div className='text-left'>{cellInfo.row.original.email}</div>
      },
      {
        Header: 'No Hp',
        id: 'nohp',
        width: '8%',
        accessor: 'nohp',
        sortType: 'basic',
        disableFilters: true,
        // filter: 'includes',
        // Filter: SelectColumnFilter,
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.no_hp}</div>
      },
      {
        Header: 'SPN',
        id: 'spn',
        width: '8%',
        accessor: 'spn',
        sortType: 'basic',
        disableFilters: true,
        // filter: 'includes',
        // Filter: SelectColumnFilter,
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.spn == 1 ? "Aktif" : "Non Aktif"}</div>
      },
      {
        Header: 'Status',
        id: 'status',
        width: '8%',
        accessor: 'status',
        sortType: 'basic',
        disableFilters: true,
        // filter: 'includes',
        // Filter: SelectColumnFilter,
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.status == 1 ? "Aktif" : "Non Aktif"}</div>
      },
      {
        Header: 'Action',
        id: 'action',
        width: '8%',
        Cell: (cellInfo) =>
          contentTableAction(
            cellInfo.row.original.id,
            cellInfo.row.original.username,
          )
      }
    ];

    return (
      <>
        {/* Main card */}
        <div className='row row-deck row-cards'>
          <div className="col-md-12">
            <Card styleBody={{ padding: 0, paddingTop: 20 }}>
              <KopkarTable
                title="Anggota"
                columns={columns}
                data={dataAnggota}
                formOne={null}
                formTwo={null}
                formThree={null}
                rowSize={[50, 100, 150]}
              />
            </Card>
          </div>

        </div>
      </>
    )
  };

  // VIEW
  const headerView = () => (
    <>
      <div className='page-header'>
        <div className='row align-items-center'>
          {/* Title */}
          <div className='col'>
            <ol className='breadcrumb'>
              <li className='breadcrumb-item Navbar_title'>
                <Link to='#' style={{ color: '#333' }}>Anggota</Link> /{' '}
                <Link to='/anggota/listanggota' style={{ color: '#333' }}>List Anggota</Link>
              </li>
            </ol>
          </div>

          {/* Tambah new anggota */}
          <div className='col-auto ml-auto d-print-none'>
            <Link to="/anggota/tambahanggota">
              <button
                type="button"
                className="btn btn-gray"
                style={{ marginLeft: 10 }}
                onClick={() => console.log('tambah anggota')}
              >
                <div className="d-flex align-items-center">
                  <Icon name="Plus" size={16} style={{ marginRight: 5 }} />{' '}
                  <span>Tambah Anggota</span>
                </div>
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  )

  const handleView = () => {
    switch (users.role) {
      case ADMIN:
        return userListView();
    }
  };
  
    
   return (
    <div className='container-fluid'>

      {headerView()}

      {/* main content */}
      {isLoading ? <LoadingView /> : handleView()}

    </div>

  );

}

export default ListAnggota;